import { gql, TypedDocumentNode } from '@apollo/client';
import {
  OvertimeEditDetails,
  OvertimeEditDetailsVariables,
} from './__generated__/OvertimeEditDetails.query';
import EmployeeFragment from '../../../hooks/useProjectEmployees/graphql/Employee.fragment';

const OvertimeEditDetailsQuery: TypedDocumentNode<
  OvertimeEditDetails,
  OvertimeEditDetailsVariables
> = gql`
  query OvertimeEditDetails(
    $overtimeId: ID!
    $thumbnailHeight: Int!
    $thumbnailWidth: Int!
    $pdfRedesignEnabled: Boolean!
  ) {
    overtime(id: $overtimeId) {
      id

      no
      alias
      date
      clientNameComputed
      draftProjectNumber
      professions @include(if: $pdfRedesignEnabled)
      clientReference @include(if: $pdfRedesignEnabled)
      descriptionComputed @include(if: $pdfRedesignEnabled)
      orderDate
      endDate
      workName
      workDescription

      images {
        id
        label
        url
        thumbnail(height: $thumbnailHeight, width: $thumbnailWidth)
      }

      employees {
        id
        hours
        extraHours
        materialSurcharge
        machinesUsage
        machinesHours

        ... on OvertimeCustomEmployee {
          fullName
          role
        }

        ... on OvertimeSAPEmployee {
          employee {
            ...Employee
          }

          optionalRole: role
          automaticRole
        }

        ... on OvertimeDeletedSAPEmployee {
          employeeId
        }
      }
    }

    viewer @include(if: $pdfRedesignEnabled) {
      id

      overtimePreferences {
        employeeAutomaticRoleSelection
      }
    }
  }

  ${EmployeeFragment}
`;

export default OvertimeEditDetailsQuery;
